import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const Certificate = RepositoryFactory.get('certificate')
const namespaced = true

const state = {
  certificate: {},
  certificates: []
}

const actions = {
  async createCertificate({ commit }, data) {
    const res = await Certificate.create(data)
    commit('addCertificate', res.data)
    return res.data
  },
  async fetchCertificates({ commit }, params) {
    const res = await Certificate.fetch({
			...params
		})
    commit('setCertificates', res.data || [])
		return res.data
  },
  async fetchCertificate({ commit }, id) {
    const res = await Certificate.fetchOne(id)
    commit('setCertificate', res.data)
		return res.data
  },
  async removeCertificate({ commit }, id) {
		const res = await Certificate.remove(id)
    commit('remove', id)
		return res.data
  },
	async updateCertificate({ dispatch}, {id, ...data}) {
		const res = await Certificate.update(id, data)
		dispatch('fetchCertificate', id)
		return res.data
	},
}

const mutations = {
  addCertificate(state, certificate) {
    state.certificates.push(certificate)
  },
  setCertificates(state, certificates) {
    state.certificates = certificates
  },
  setCertificate(state, certificate) {
    state.certificate = certificate
  },
  remove(state, id) {
    state.certificates = state.certificates.filter(certificate => certificate.id !== id)
    state.certificate = {}
  }
}

const getters = {
  getList: state => {
    return state.certificates
  },
  getOne: state => {
    return state.certificate
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
